<script setup lang="ts">

import Translator from "@/utils/common/Translator.ts";
import NamaIcon from "@/components/icons/NamaIcon.vue";

defineProps<{ title: string, icon?: string }>()

</script>

<template>
  <div class="tw-text-start tw-ps-5 tw-mb-3 tw-flex tw-flex-row tw-items-center">
    <NamaIcon :default-icon="icon" class="tw-size-5 tw-text-xl active-primary"/>
    <span
      class="tw-ps-3 tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-medium"
      v-text="Translator.translateId(title)"/>
  </div>
</template>

<style scoped>

</style>
